import React, { Component } from 'react';
import logo from '../logo.svg';
import '../App.css';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <footer>
          <iframe src="https://www.google.com/maps/embed/v1/place?q=510%20san%20mateo%20avve&key=AIzaSyDOQq2JStkcXhfmVGqNATlfNPvejORVUYY" allowFullScreen></iframe>
          <div className="contact">
            <h1>Fisher & Ho</h1>
            <div className="container">
              <p>510 San Mateo Avenue<br />
              San Bruno, CA 94066<br /><br />

              <strong>Phone:</strong> 650-583-2905<br />
              <strong>Fax:</strong> 650-583-4673<br /><br />

              <a href="mailto:fisherho@sanbrunocable.com">fisherho@sanbrunocable.com</a></p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js